export const FETCH_MANAGERS = "FETCH_MANAGERS";
export const SAVE_MANAGER_PERMISSIONS = "SAVE_MANAGER_PERMISSIONS";
